











import Vue from 'vue';

interface Props {
  labels: string[];
  pill: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: 'HeadlineLabels',
  props: {
    labels: {
      type: Array,
      required: true,
    },
    pill: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
});
